import { EditableContent } from '../../edit/EditableContent';
import { LucideIcon } from '../../icons/LucideIcon';
import { resolveSectionLucideIcon } from '../../icons/ctaLucideMap';
import { pickBlockField } from '../../lib/localized';
import { parseHoursSchedule } from '../../lib/splitHoursLines';
import type { BlockRenderProps } from '../../types';

export function SimpleOpeningHours({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const sectionIconKey = pickBlockField(block.content, 'sectionIcon', locale);
  const hours = pickBlockField(block.content, 'hours', locale);
  const hoursRows = parseHoursSchedule(hours);
  const note = pickBlockField(block.content, 'note', locale);
  const target = isActive ? activeEditTarget : null;
  const sectionIcon = resolveSectionLucideIcon(sectionIconKey, 'hours');

  return (
    <section
      className={['ws-opening-hours', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="hours"
    >
      <div className="ws-opening-hours__inner">
        <div className="ws-opening-hours__header">
          <EditableContent
            as="span"
            fieldKey="sectionIcon"
            editable={editable}
            activeEditTarget={target}
            className="ws-opening-hours__icon-hit"
          >
            <LucideIcon icon={sectionIcon} size="md" className="ws-opening-hours__icon" />
          </EditableContent>
          <EditableContent
            as="h2"
            fieldKey="sectionTitle"
            editable={editable}
            activeEditTarget={target}
            className="ws-opening-hours__title"
          >
            {sectionTitle}
          </EditableContent>
        </div>
        {hoursRows.length > 0 ? (
          <EditableContent
            as="div"
            fieldKey="hours"
            editable={editable}
            activeEditTarget={target}
            className="ws-hours-schedule ws-opening-hours__hours"
          >
            {hoursRows.map((row, index) => (
              <div key={index} className="ws-hours-schedule__row">
                <span className="ws-hours-schedule__day">{row.day}</span>
                <span className="ws-hours-schedule__time">{row.time}</span>
              </div>
            ))}
          </EditableContent>
        ) : null}
        {note || editable ? (
          <EditableContent
            fieldKey="note"
            editable={editable}
            activeEditTarget={target}
            className="ws-opening-hours__note"
          >
            {note}
          </EditableContent>
        ) : null}
      </div>
    </section>
  );
}
